import apiAthleteResult from '@/api/athlete-result'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getAthleteResultStart: '[athlete result] Get athlete result start',
  getAthleteResultSuccess: '[athlete result] Get athlete result success',
  getAthleteResultFailure: '[athlete result] Get athlete result failure'
}

export const actionTypes = {
  getAthleteResult: '[athlete result] Get athlete result'
}

const mutations = {
  [mutationTypes.getAthleteResultStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getAthleteResultSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getAthleteResultFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getAthleteResult](context) {
    context.commit(mutationTypes.getAthleteResultStart)
    return new Promise(resolve => {
      apiAthleteResult
        .getAthleteResult()
        .then(response => {
          context.commit(mutationTypes.getAthleteResultSuccess, response.data)
          resolve(response.data)
        })
        .catch(error => {
          context.commit(mutationTypes.getAthleteResultFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
